import {EventAttributesState} from "@/store/cdp/event_attributes/types";
import {Module} from "vuex";
import {RootState} from "@/store/types";
import {actions} from "@/store/cdp/event_attributes/actions";
import {getters} from "@/store/cdp/event_attributes/getters";
import {mutations} from "@/store/cdp/event_attributes/mutations";

export const state: EventAttributesState = {
    eventAttributes: []
}

export const cdpEventAttributes: Module<EventAttributesState, RootState> = {
    state,
    actions,
    getters,
    mutations
}
